import { createContext } from 'react';

export type SizeValue = { size: string; value: number };

export interface CustomTabLayoutApi {
  changeLayoutHeight?: (id: string, values: SizeValue[]) => void;
  markVolSurfaceSmileExpanded?: (id: string, expanded: boolean) => void;
}

export const CustomTabLayoutContext = createContext<CustomTabLayoutApi>({});

export default CustomTabLayoutContext;
